export default "__VITE_ASSET__DmMi0ANY__"